module.exports = __webpack_public_path__ + "static/img/NOAH-DAW.acacfa4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/NOAH-DAW.jpg
// module id = he5I
// module chunks = 0